/** How close to the bottom (px) still counts as needing another page. */
export const INFINITE_SCROLL_BOTTOM_PX = 24;

export const isUnfilledScrollContainer = (scrollHeight: number, clientHeight: number): boolean => {
    if (scrollHeight <= 0 || clientHeight <= 0) {
        return false;
    }

    return scrollHeight <= clientHeight + 1;
};

export const isNearScrollBottom = (
    scrollTop: number,
    scrollHeight: number,
    clientHeight: number,
    bottomPx = INFINITE_SCROLL_BOTTOM_PX,
): boolean => {
    if (scrollHeight <= 0 || clientHeight <= 0) {
        return false;
    }

    return scrollTop + clientHeight >= scrollHeight - bottomPx;
};

/**
 * Prefetch once the user has scrolled through the first half of the loaded rows.
 */
export const isPastInfiniteScrollThreshold = (
    scrollTop: number,
    scrollHeight: number,
    clientHeight: number,
): boolean => {
    if (scrollHeight <= 0 || clientHeight <= 0) {
        return false;
    }

    return scrollTop + clientHeight >= scrollHeight * 0.5;
};
